import { useTranslation } from 'react-i18next'
import Sheet from './Sheet'
import ActionBar from './ActionBar'
import { MenuItem, Select, FormControl, InputLabel } from '@mui/material';

export default function SelectLocation(props) {
    const {
      location,
      saveLocation,
      showChangeLocation,
      setShowChangeLocation,
    } = props;
    const { t } = useTranslation();

    return (
        <Sheet
            open={showChangeLocation}
            onClose={() => setShowChangeLocation(false)}
            title={t('common.selectLocation.title')}
            actions={<ActionBar cancel={{ label: t('common.cancel'), onClick: () => setShowChangeLocation(false) }} />}
        >
            <FormControl fullWidth variant="outlined">
                <InputLabel id="location-label">{t('common.selectLocation.label')}</InputLabel>
                <Select
                    fullWidth
                    id="location"
                    labelId="location-label"
                    value={location || ''}
                    label={t('common.selectLocation.label')}
                    onChange={e => saveLocation(e.target.value)}
                    >
                    <MenuItem value='newark'>Newark</MenuItem>
                    <MenuItem value='longbranch'>Long Branch</MenuItem>
                </Select>
            </FormControl>
        </Sheet>
    )
}
